import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

export const getCustomerName = (params) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetCustomer`,
    method: 'get',
    params,
  });
};

let getVendorPurchaseOrdersEffectCancelToken = () => {};
export const getVendorPurchaseOrdersEffect = (data) => {
  getVendorPurchaseOrdersEffectCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetPurchaseOrder`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getVendorPurchaseOrdersEffectCancelToken = c;
    }),
  });
};

export const getPOInfoEffect = (data) => {
  getVendorPurchaseOrdersEffectCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetPoItem`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getVendorPurchaseOrdersEffectCancelToken = c;
    }),
  });
};

export const getPackageTypeEffect = () => {
  getVendorPurchaseOrdersEffectCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetPackageType`,
    method: 'GET',
    cancelToken: new CancelToken(function executor(c) {
      getVendorPurchaseOrdersEffectCancelToken = c;
    }),
  });
};

export const getPackageTypesService = () => {
  return axiosInstance.request({
    url: `${API.POV2}/GetPackageType`,
    method: 'GET',
  });
};

export const getPackagesEffect = (data) => {
  getVendorPurchaseOrdersEffectCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/PckageRead`,
    method: 'get',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getVendorPurchaseOrdersEffectCancelToken = c;
    }),
  });
};

export const getBarCodeDetails = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GenerateBarcode`,
    method: 'GET',
    params: data,
  });
};

export const saveRegularOrderData = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/PoItemValidation`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

let getFooterValuesCancelToken = () => {};
export const getFooterValues = (data) => {
  getFooterValuesCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetFooterContent`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getFooterValuesCancelToken = c;
    }),
  });
};

export const savePackageEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/SavePackage`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const saveShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/CreateShipmentValidation`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getShippersList = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetShipper`,
    method: 'post',
    data: data,
  });
};
export const getConsigneeList = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetConsignee`,
    method: 'post',
    data: data,
  });
};

export const getShipmentDetailsLists = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetShipmentDetails`,
    method: 'post',
    data: data,
  });
};

export const getShipmentItemDetailsLists = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetShipmentItemDetails`,
    method: 'post',
    data: data,
  });
};

export const getShipmentSummaryList = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetShipmentSummery`,
    method: 'post',
    data: data,
  });
};

export const getShipmentLadingList = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetBillOfLad`,
    method: 'post',
    data: data,
  });
};

export const createPovShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/SaveShipment`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getRoutingGuideEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetRoutingGuide`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const saveVendorAddressEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/SaveVendorAddress`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteVendorAddressValue = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/DeleteVendorAddress`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const cancelShipmentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/CancelDraftShipment`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
  });
};

let getShipmentInformationCancelToken = () => {};
export const getShipmentInformation = (data) => {
  getShipmentInformationCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetShipmentInformation`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getShipmentInformationCancelToken = c;
    }),
  });
};

let getShipmentItemDetailsCancelToken = () => {};
export const getShipmentItemDetails = (data) => {
  getShipmentItemDetailsCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetShipmentItemDetails`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getShipmentItemDetailsCancelToken = c;
    }),
  });
};

let getVendorSearchValuesCancelToken = () => {};
export const getVendorSearchValues = (params) => {
  getVendorSearchValuesCancelToken();
  return axiosInstance.request({
    url: `${API.POV2}/GetVendorAddress`,
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getVendorSearchValuesCancelToken = c;
    }),
  });
};

export const getCustomerRouterSettingService = (params) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetCustomerRoutingSettings`,
    method: 'get',
    params,
  });
};

export const resetOrderListService = (params) => {
  return axiosInstance.request({
    url: `${API.POV2}/ResetReleaseOrder`,
    method: 'POST',
    data: params,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const shipDateChangeEmailNotification = (params) => {
  return axiosInstance.request({
    url: `${API.POV2}/ShipDateChangeEmailNotification`,
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getVendorFieldsVisibilityEffect = () => {
  return axiosInstance.request({
    url: `${API.POV2}/GetVendorFieldsVisiblity`,
    method: 'get',
  });
};

export const validateEarlyShipmentRestrictionEffect = (data) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetEarlyShipmentRestriction`,
    method: 'POST',
    data: data,
  });
};

export const getVendorPortCodes = (params) => {
  return axiosInstance.request({
    url: `${API.POV2}/GetVendorPortCode`,
    method: 'get',
    params,
  });
};
